<div class="user-property-heading-row">
  <div>
    <h3>Manage Calendar</h3>
    <div class="address-block-with-icon">
      <div class="address-block-icon">
        <mat-icon class="location-color">location_on</mat-icon>
      </div>
      <div class="address-block-address">
        {{ property?.address?.street }}<br/>{{ property?.address?.city }}, {{ property?.address?.state }}
      </div>
    </div>
  </div>
  <div>
    <button mat-flat-button class="metallic-text-btn-blue" (click)="add()">
      <mat-icon matPrefix>add</mat-icon>
      Add
    </button>
  </div>
</div>

@if (avails) {
  <div class="user-property-list-table-container mat-elevation-z8">

    <mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Date </mat-header-cell>
        <mat-cell *matCellDef="let pav"> {{ pav.date | date: 'MMMM dd, yyyy' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
        <mat-cell *matCellDef="let pav"> {{ pav.status ?? '' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="reason">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Blocked Reason </mat-header-cell>
        <mat-cell *matCellDef="let pav"> {{ pav.blockedReason }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
        <mat-cell *matCellDef="let pav">

          <button mat-icon-button color="primary" (click)="editDate(pav.id)" matTooltip="Manage Calendar">
            <mat-icon>edit_calendar</mat-icon>
          </button>

          <button mat-icon-button color="primary" (click)="removeDate(pav.id)" matTooltip="Remove">
            <mat-icon>delete</mat-icon>
          </button>

        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="['date', 'status', 'reason', 'actions']"></mat-header-row>

      <mat-row *matRowDef="let row; columns: ['date', 'status', 'reason', 'actions'];"></mat-row>
    </mat-table>

    <mat-paginator #paginator [pageSizeOptions]="[10, 25, 100]" aria-label="Select page of dates">
    </mat-paginator>
  </div>
}